/* eslint-disable react/no-array-index-key */
import React from "react";
import { FormMessage, Select, Spinner } from "@xometry/xometry_loft";

import { Section, FullWidth } from "./Shared.style";
import { SelectStyle, AddOptionLink } from "./LoftAddOptionSelect.styles";

type LoftFilesSelectProps = {
  onChange: (data: string) => void;
  options: { label: string; value: string }[];
  noOptionsLabel?: JSX.Element | string;
  addNewOptionLabel: JSX.Element | string;
  invalid: boolean;
  disabled: boolean;
  loading?: boolean;
  name: string;
  defaultValue?: string;
  value?: string;
  description?: string;
};

const LoftAddOptionSelect = ({
  onChange,
  options,
  noOptionsLabel,
  addNewOptionLabel,
  invalid,
  disabled,
  loading = false,
  name,
  defaultValue,
  value,
  description,
}: LoftFilesSelectProps) => {
  const hasOptions = options.some(({ value }) => !!value);
  if (hasOptions && loading) {
    return <Spinner scale="panel" />;
  }
  return (
    <>
      <div css={[Section, FullWidth]}>
        {hasOptions ? (
          <>
            <Select
              name={name}
              invalid={invalid}
              disabled={disabled}
              onChange={e => {
                onChange(e.currentTarget.value);
              }}
              css={SelectStyle}
              defaultValue={defaultValue}
              value={value}
            >
              {options.map((opt, idx) => {
                if (opt === null) {
                  return (
                    <option
                      key={`empty_${idx}`}
                      value=""
                      disabled
                      label={description}
                    />
                  );
                }
                const { label, value } = opt;
                return (
                  <option key={value + idx} value={value}>
                    {label}
                  </option>
                );
              })}
            </Select>
            <AddOptionLink>{addNewOptionLabel}</AddOptionLink>
          </>
        ) : (
          noOptionsLabel && <AddOptionLink>{noOptionsLabel}</AddOptionLink>
        )}
        {invalid && <FormMessage invalid>Invalid file</FormMessage>}
      </div>
    </>
  );
};

LoftAddOptionSelect.defaultProps = {
  value: undefined,
  defaultValue: undefined,
  description: undefined,
  noOptionsLabel: undefined,
  loading: false,
};

export default LoftAddOptionSelect;
